import React from 'react';
import NavigationBar from '../components/NavigationBar';
import { Link } from 'react-router-dom';
import './Impressum.css';

const Mehr = () => {
  return (
    <>
      <NavigationBar />
      <div className="impressum-page">
        <header className="impressum-header">
          <h1>Über diesen Kulturatlas</h1>
        </header>

        <section className="impressum-section">
          <p>
            Ein lebendiger Platz im Herzen Berlins, umgeben von Theatern, Kinos,
            politischer Geschichte und pulsierender Gegenwartskunst – dieser
            Kulturatlas dokumentiert das einzigartige Ensemble aus Architektur,
            Kunst und städtischem Leben an einem der bedeutendsten Orte der Stadt.
          </p>
          <p>
            Das Projekt ist nicht kommerziell und verfolgt ausschließlich
            kulturelle und dokumentarische Zwecke. Wesentlicher Unterstützer ist
            der{' '}
            <a
              href="https://www.rosa-luxemburg-platz.net/satzung/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Verein zur Förderung von Kunst und Kultur am Rosa-Luxemburg-Platz&nbsp;e.V.
            </a>
          </p>
        </section>

        <section className="impressum-section">
          <h2>Kontakt</h2>
          <address>
            Jörg Geissler<br />
            Tölzer Str. 7<br />
            82064 Strasslach-Dingharting<br />
            <br />
            Telefon: <a href="tel:+4917843477531">+49 (0) 178 434 7753</a><br />
            E-Mail: <a href="mailto:joerg@geissler.com">joerg@geissler.com</a>
          </address>
        </section>

        <nav className="mehr-links">
          <Link to="/impressum">Impressum</Link>
          <Link to="/datenschutz">Datenschutz</Link>
        </nav>
      </div>
    </>
  );
};

export default Mehr;
